<div class="flex items-center justify-center dialog-header ">
    Test Call

    <div class="absolute right-2">
        <button (click)="closeModal()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>
<div class="dialog-content">
    <div>
        <form [formGroup]="phoneForm" (ngSubmit)="onProceed()" style="width: 100%; height: 213px; margin-top: 10px;">
            <div style="font-weight: 600; margin-top: -13px; margin-bottom: 5px;">
                Contact Number
            </div>
            <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="['in']" [enableAutoCountrySelect]="true"
                [enablePlaceholder]="true" [searchCountryFlag]="true" (keyup.enter)="onProceed()"
                [selectFirstCountry]="true" [formControlName]="'phone'" [maxLength]="15">
            </ngx-intl-tel-input>

            <div *ngIf="!phoneForm.valid">
                <div class="invalid-phone-text">Please enter a valid phone number</div>
            </div>
        </form>
    </div>
    <div class="flex justify-end  mt-4">
        
        <p-button label="Call" icon="pi pi-phone"
        [loading]="btnLoading"
         severity="danger"  class="flex justify-end"
            (click)="onProceed()"></p-button>

    </div>
</div>

